import React from 'react';
import { useT } from '@repo/common';
import { PAYMENT_COLUMN_CLASS as COL } from './paymentColumns';

const HeaderItem = ({ children, className }) => {
  return (
    <div
      className={`flex justify-center items-center px-1 py-4 gap-[10px] relative z-10 ${className}`}
    >
      <span className='typo-b13Strong text-text-secondary'>{children}</span>
    </div>
  );
};

/* 표 머리글은 tabletV(1180px) 이상에서만 보인다. 그 아래는 행이 카드로 바뀐다. */
const PaymentsListHeader = ({ type = 'pending' }) => {
  const t = useT();
  return (
    <div className='hidden tabletV:flex flex-col w-full items-start px-2 bg-grayscale-gray02/30 rounded-t-[30px]'>
      <div className='flex w-full'>
        <HeaderItem className={COL.date}>
          {type === 'history' ? t('Date', '날짜') : t('Pending Since', '대기 시작일')}
        </HeaderItem>
        <HeaderItem className={COL.invoice}>{t('Invoice No.', '인보이스 번호')}</HeaderItem>
        <HeaderItem className={COL.item}>{t('Item', '항목')}</HeaderItem>
        <HeaderItem className={COL.user}>{t('User', '사용자')}</HeaderItem>
        <HeaderItem className={COL.amount}>{t('Amount', '금액')}</HeaderItem>
        <HeaderItem className={COL.status}>
          {type === 'history' ? t('Status', '상태') : t('Time left', '남은 시간')}
        </HeaderItem>
        <HeaderItem className={COL.contact}>-</HeaderItem>
        <div className={`flex justify-center items-center ${COL.icon}`} />
        <div className={`flex justify-center items-center ${COL.icon}`} />
      </div>
      <div className='bg-grayscale-gray02/70 h-5' />
    </div>
  );
};

export default PaymentsListHeader;
